var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#707070;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.4,5.5H23.6a2.9,2.9,0,0,1,2.9,2.9V18.6a2.9,2.9,0,0,1-2.9,2.9H16l-5.68,4.88a.52.52,0,0,1-.33.12.54.54,0,0,1-.21-.05A.48.48,0,0,1,9.5,26V21.5H8.4a2.9,2.9,0,0,1-2.9-2.9V8.4A2.9,2.9,0,0,1,8.4,5.5ZM6.5,18.6a1.9,1.9,0,0,0,1.9,1.9H10a.5.5,0,0,1,.5.5v3.91l5-4.29a.5.5,0,0,1,.33-.12H23.6a1.9,1.9,0,0,0,1.9-1.9V8.4a1.9,1.9,0,0,0-1.9-1.9H8.4A1.9,1.9,0,0,0,6.5,8.4Z",
    transform: "translate(-5.5 -5.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.76,13H15.5V9.26a.5.5,0,0,1,1,0V13h3.74a.5.5,0,0,1,0,1H16.5v3.74a.5.5,0,0,1-1,0V14H11.76a.5.5,0,0,1,0-1Z",
    transform: "translate(-5.5 -5.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMessage);
export default __webpack_public_path__ + "static/media/add_message.5c9080116dbfa1d293b2804c9e564b80.svg";
export { ForwardRef as ReactComponent };